export default __webpack_public_path__ + "static/media/clio-colour-1.1bef172d.jpg";